import axios from "axios";
import { API_URL } from "../config/constant";

export function initiateRamfincorpApplication(
  ramfincorpPayload,
  handleFormSubmit,
  setIsDisableBtn,
  setDisplay,
  navigate
) {
  axios
    .post(API_URL + "ramfincorp/initiate-application", ramfincorpPayload)
    .then((res) => {
      setIsDisableBtn(false);
      setDisplay("none");
      navigate("/congratulations-ramfin");
    })
    .catch((e) => {
      setIsDisableBtn(false);
      setDisplay("none");
      if (e.response) {
        handleFormSubmit();
      }
    });
}